module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user.company) ? _c('li', {
    staticClass: "rent-pre-registrations-messages-menu dropdown"
  }, [_c('audio', {
    ref: "newRents",
    attrs: {
      "src": _vm.cdn('sound.mp3')
    }
  }), _vm._v(" "), _c('audio', {
    ref: "newRentSound",
    attrs: {
      "src": _vm.cdn('beep.mp3')
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-lg fa-comments-o"
  }), (_vm.unreadMessages && _vm.unreadMessages.count > 0) ? _c('span', {
    staticClass: "bell-badge"
  }, [_vm._v(_vm._s(_vm.unreadMessages.count))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.unreadMessages && _vm.unreadMessages.messages.length > 0) ? [_c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Mensagens não lidas")]), _vm._v(" "), _vm._l((_vm.unreadMessages.messages), function(message) {
    return [_c('li', {
      staticClass: "divider",
      attrs: {
        "role": "separator"
      }
    }), _vm._v(" "), _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'orders_list',
          query: {
            orderId: message.order_id,
            tab: (message.received ? 'received' : 'made')
          }
        }
      }
    }, [_c('div', {
      staticClass: "pull-right text-silver font-10"
    }, [_vm._v(_vm._s(_vm._f("time")(message.created_at)))]), _vm._v(" "), (message.chat) ? _c('small', {
      staticClass: "text-silver"
    }, [_c('b', [_vm._v(_vm._s(message.client))])]) : _c('small', {
      staticClass: "text-silver"
    }, [_c('b', [_vm._v(_vm._s(message.fantasy_name))])]), _vm._v(" "), _vm._l((message.messages), function(m, i) {
      return _c('div', {
        key: i
      }, [_c('br'), _c('span', {
        domProps: {
          "innerHTML": _vm._s(m)
        }
      })])
    }), _vm._v(" "), _c('br'), _c('div', {
      staticClass: "text-right text-silver font-10"
    }, [_vm._v("#" + _vm._s(message.order_id) + " - " + _vm._s(message.sku_title))])], 2)], 1)]
  })] : _c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v("Nenhuma mensagem não lida no momento")])], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ebac198!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/ChatMenu.vue
// module id = 987
// module chunks = 34